import { useFeatureToggle } from 'components/FeatureToggle/useFeatureToggle';
import { FeatureToggles } from 'enums/featureToggles';
import { lazyLoad } from 'utils/loadable';

export const JobSearchPage = lazyLoad(
  () => import('./JobSearchPage'),
  module => module.JobSearchPage,
);

export const JobShareDetail = lazyLoad(
  () => import('./JobShareDetail'),
  module => module.JobShareDetail,
);

export const ACSJobSearchPage = lazyLoad(
  () => import('./CognitiveJobSearch/CognitiveJobSearchPage'),
  module => module.CognitiveJobSearchPage,
);

export const FeatureToggledJobSearch = () => {
  const isACSJobSearch = useFeatureToggle(FeatureToggles.ENABLE_ACS_JOB_SEARCH);

  let pageToLoad = isACSJobSearch
    ? lazyLoad(
        () => import('./CognitiveJobSearch/CognitiveJobSearchPage'),
        module => module.CognitiveJobSearchPage,
      )
    : lazyLoad(
        () => import('./JobSearchPage'),
        module => module.JobSearchPage,
      );

  return pageToLoad;
};

export const FeatureToggledJobDetails = () => {
  const isACSJobSearch = useFeatureToggle(FeatureToggles.ENABLE_ACS_JOB_SEARCH);

  let pageToLoad = isACSJobSearch
    ? lazyLoad(
        () =>
          import(
            './CognitiveJobSearch/CognitiveJobDetails/CognitiveJobDetailsPage'
          ),
        module => module.CognitiveJobDetailsPage,
      )
    : lazyLoad(
        () => import('./JobShareDetail'),
        module => module.JobShareDetail,
      );

  return pageToLoad;
};
